export const ACTIONS_LICENSE_TYPE = {
  INVALIDATE: 'LICENSE_TYPES_INVALIDATE',
  RECEIVE: 'LICENSE_TYPES_RECEIVE',
  DELETE: 'LICENSE_TYPE_DELETE',
  UPDATE: 'LICENSE_TYPE_UPDATE',
};

const licenseTypeConstants = {};

export default licenseTypeConstants;
